import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import Drp_City from '../ProvinceCity/Drp_City.js';
import Drp_Province from '../ProvinceCity/Drp_Province.js';


const UserIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const CityRef = useRef();
    const ProvinceRef = useRef();
    const DeleteRef = useRef()
    const [UserList, setUserList] = useState([]);
    const [RoleList, setRoleList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty());
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [NationalNo, setNationalNo] = useState('');
    const [Tel, setTel] = useState('');
    const [Mobile, setMobile] = useState('');
    const [Address, setAddress] = useState('');
    const [City, setCity] = useState(-1);
    const [Province, setProvince] = useState(-1);
    const [CustomerType, setCustomerType] = useState(-1);
    const [UserName, setUserName] = useState('');
    const [Password, setPassword] = useState('');
    const [IsCoWorker, setIsCoWorker] = useState(0);
    const [IsCustomer, setIsCustomer] = useState(0);
    const [IsSupplier, setIsSupplier] = useState(0);
    const [IsActive, setIsActive] = useState(true);

    const [SearchFirstName, setSearchFirstName] = useState('');
    const [SearchLastName, setSearchLastName] = useState('');
    const [SearchNationalNo, setSearchNationalNo] = useState('');
    const [SearchTel, setSearchTel] = useState('');
    const [SearchMobile, setSearchMobile] = useState('');
    const [SearchAddress, setSearchAddress] = useState('');
    const [SearchCity, setSearchCity] = useState(-1);
    const [SearchProvince, setSearchProvince] = useState(-1);
    const [SearchCustomerType, setSearchCustomerType] = useState(-1);
    const [SearchIsCoWorker, setSearchIsCoWorker] = useState(-1);
    const [SearchIsCustomer, setSearchIsCustomer] = useState(-1);
    const [SearchIsSupplier, setSearchIsSupplier] = useState(-1);
    const [SearchIsActive, setSearchIsActive] = useState(1);




    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    const Province_Change = (value) => {
        setProvince(value);
        CityRef.current.BindCity(value, -1)

    }
    const City_Change = (value) => {
        setCity(value);

    }


    //#region Methods

    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/User/Search', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'FirstName': SearchFirstName,
                    'LastName': SearchLastName,
                    'NationalNo': SearchNationalNo,
                    'Tel': SearchTel,
                    'Mobile': SearchMobile,
                    'Address': SearchAddress,
                    'CityId': SearchCity,
                    'ProvinceId': SearchProvince,
                    'CustomerType': SearchCustomerType,
                    'IsCoWorker': SearchIsCoWorker,
                    'IsCustomer': SearchIsCustomer,
                    'IsSupplier': SearchIsSupplier,
                    'IsActive': SearchIsActive
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            FirstName: result[i].firstName,
                            LastName: result[i].lastName,
                            City: result[i].city,
                            Province: result[i].province,
                            CustomerType: result[i].customerType,
                            Address: result[i].address,
                            Mobile: result[i].mobile,
                            Tel: result[i].tel,
                            IsCoWorker: result[i].isCoWorker,
                            IsSupplier: result[i].isSupplier,
                            IsCustomer: result[i].isCustomer,

                        })
                    }
                    setUserList(tmp)
                })
        )
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const Reset = () => {
        setId(General.GuidEmpty());
        setFirstName('');
        setLastName('');
        setNationalNo('');
        setTel('');
        setMobile('');
        setAddress('');
        setCity(-1);
        setProvince(-1);
        setCustomerType(0);
        setUserName('');
        setPassword('');
        setIsCoWorker(0);
        setIsCustomer(0);
        setIsSupplier(0);
        setIsActive(true);
        setRoleList([]);
    }

    const Save = () => {
        if (FirstName == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("نام اجباری می باشد")), 'topCenter')
            return;
        }
        if (LastName == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("نام خانوادگی اجباری می باشد")), 'topCenter')
            return;
        }
        if (Mobile == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره همراه اجباری می باشد")), 'topCenter')
            return;
        }
        if (Tel == "" && (IsCustomer == 1 || IsSupplier == true)) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره ثابت اجباری می باشد")), 'topCenter')
            return;
        }
        if ((City == "-1" || Province == -1) && IsCustomer == true) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شهر / استان اجباری می باشد")), 'topCenter')
            return;
        }
        if (NationalNo == "" && IsSupplier == true) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("کد ملی اجباری می باشد")), 'topCenter')
            return;
        }
        if (IsCustomer == true && Address == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("آدرس اجباری می باشد")), 'topCenter')
            return;
        }
        if (Password == "" && IsCoWorker == true) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("رمز عبور اجباری می باشد")), 'topCenter')
            return;
        }

        if (UserName == "" && IsCoWorker == true) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("کلمه عبور اجباری می باشد")), 'topCenter')
            return;
        }
        if (IsCoWorker == false && IsCustomer == false && IsSupplier == false) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("نوع کاریر اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": Id,
                "FirstName": FirstName,
                "LastName": LastName,
                "Password": Password,
                "UserName": UserName,
                "NationalNo": NationalNo,
                "Address": Address,
                "Tel": Tel,
                "Mobile": Mobile,
                "ProvinceId": Province,
                "CityId": City,
                "CustomerType": CustomerType ? 1 : 0,
                "IsSupplier": IsSupplier ? 1 : 0,
                "IsCustomer": IsCustomer ? 1 : 0,
                "IsCoWorker": IsCoWorker ? 1 : 0,
                "IsActive": IsActive ? 1 : 0,
                "Roles": RoleList
            },
            url: General.ApiRoute() + "/User/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        Search();
                        Reset();
                        setShowModal(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }
    const ShowDelete = (id, fullName) => {
        DeleteRef.current.Get(1, id, fullName);
    }
    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/User/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setFirstName(result.firstName);
                    setLastName(result.lastName);
                    setNationalNo(result.nationalNo);
                    setTel(result.tel);
                    setMobile(result.mobile);
                    setAddress(result.address);
                    setCity(result.cityId);
                    setProvince(result.provinceId);
                    setCustomerType(result.customerType == 0 ? false : true);
                    setUserName(result.userName);
                    setPassword(result.password);
                    setIsCoWorker(result.isCoWorker == 0 ? false : true);
                    setIsCustomer(result.isCustomer == 0 ? false : true);
                    setIsSupplier(result.isSupplier == 0 ? false : true);
                    setIsActive(result.isActive == 0 ? false : true);

                    var tmp = []
                    console.dir(result.roles)
                    for (var i = 0; i < result.roles.length; i++) {
                        console.dir(result.roles)

                        tmp.push({
                            Id: result.roles[i].id,
                            Title: result.roles[i].title,
                            IsSelected: result.roles[i].isSelected,

                        })
                        console.dir(tmp)
                    }

                    setRoleList(tmp)


                    ProvinceRef.current.BindProvince(result.provinceId);
                    CityRef.current.BindCity(result.provinceId, result.cityId);
                })
        )
    }
    const ShowNew = () => {
        setShowModal(true);
        Reset();
        GetRole();
        setTimeout(() => {
            ProvinceRef.current.BindProvince(-1);

        }, 1000);

    }

    const GetRole = () => {

        trackPromise(
            fetch(General.ApiRoute() + '/Role/GetAll', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'IsActive': 1
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Id: result[i].id,
                            Title: result[i].title,
                            IsSelected: 0,

                        })
                    }
                    setRoleList(tmp)
                })
        )
    }

    const CheckedRole = (checked, roleId) => {
        var temp = [...RoleList];
        var index = temp.findIndex(x => x.Id == roleId);
        if (index != -1) {
            temp[index].IsSelected = checked ? 1 : 0;
        }
        setRoleList(temp);
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 1);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }



    useEffect(() => {
        CheckPermission();
        document.title = "کاربران ";
    }, [])
    //#endregion







    return (

        <Layout title="کاربران">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={420}
                                    data={UserList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column fullText className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText className="w-80p" sortable resizable>
                                        <rsuite.Table.HeaderCell>نام</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="FirstName" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText className="w-80p" sortable resizable>
                                        <rsuite.Table.HeaderCell>نام خانوادگی</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="LastName" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText className="w-80p" sortable resizable>
                                        <rsuite.Table.HeaderCell>کاربری</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText className="w-80p" sortable resizable>
                                        <rsuite.Table.HeaderCell>موبایل</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Mobile" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText className="w-80p" sortable resizable>
                                        <rsuite.Table.HeaderCell>تلفن ثابت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Tel" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} className="w-80p" sortable resizable>
                                        <rsuite.Table.HeaderCell>آدرس</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Address" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column width={60} fixed="right" className='float-start'>
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="xl"  backdrop="static" keyboard={false}  >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف کاربران </b></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Row className='p-1'>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsCoWorker(checked)} checked={IsCoWorker} value={IsCoWorker} /> &nbsp; کاربر سیستم می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsCustomer(checked)} checked={IsCustomer} value={IsCustomer} /> &nbsp;  مشتری می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={IsCustomer == true ? '' : 'hide'}>
                                <rsuite.Checkbox onChange={(e, checked) => setCustomerType(checked)} checked={CustomerType} value={CustomerType} /> &nbsp; همکار می باشد
                            </rsuite.Col>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsSupplier(checked)} checked={IsSupplier} value={IsSupplier} /> &nbsp;  تامین کننده می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp; فعال می باشد

                            </rsuite.Col>
                        </rsuite.Row>
                        <hr />
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={FirstName == "" ? 'text-danger' : 'hide'} />  <label>نام</label>
                                <rsuite.Input value={FirstName} onChange={(e) => setFirstName(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={LastName == "" ? 'text-danger' : 'hide'} />  <label>نام خانوادگی</label>
                                <rsuite.Input value={LastName} onChange={(e) => setLastName(e)} />
                            </rsuite.Col>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={IsCoWorker == 1 && UserName == "" ? 'text-danger' : 'hide'} />  <label>نام کاربری</label>
                                <rsuite.Input value={UserName} onChange={(e) => setUserName(e)} />
                            </rsuite.Col>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={IsCoWorker == 1 && Password == "" ? 'text-danger' : 'hide'} />  <label>رمز عبور </label>
                                <rsuite.Input value={Password} onChange={(e) => setPassword(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={IsSupplier == 1 && NationalNo == "" ? 'text-danger' : 'hide'} />  <label>کد ملی  </label>
                                <rsuite.Input value={NationalNo} onChange={(e) => setNationalNo(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={Mobile == "" ? 'text-danger' : 'hide'} />  <label>شماره همراه  </label>
                                <rsuite.Input value={Mobile} onChange={(e) => setMobile(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={(IsCustomer == 1 || IsSupplier == 1) && Tel == "" ? 'text-danger' : 'hide'} />  <label>شماره ثابت  </label>
                                <rsuite.Input value={Tel} onChange={(e) => setTel(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={IsCustomer == 1 && Province == "-1" ? 'text-danger' : 'hide'} />  <label>استان   </label>
                                <Drp_Province className="rs-input" value={Province} onChange={Province_Change} ref={ProvinceRef} />
                            </rsuite.Col>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={IsCustomer == 1 && City == "-1" ? 'text-danger' : 'hide'} />  <label>شهر   </label>
                                <Drp_City className="rs-input" value={City} onChange={City_Change} ref={CityRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={IsCustomer == 1 && Address == "" ? 'text-danger' : 'hide'} />  <label>آدرس   </label>
                                <rsuite.Input value={Address} onChange={(e) => setAddress(e)} />
                            </rsuite.Col>

                        </rsuite.Row>
                        <rsuite.Row className={IsCoWorker == 1 ? "" : 'hide'}>
                            <hr />
                            {RoleList.map(role => (
                                <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className='p-3'>
                                    <rsuite.Checkbox onChange={(e, checked) => CheckedRole(checked, role.Id)} checked={role.IsSelected} value={role.IsSelected} /> &nbsp;  {role.Title}
                                </rsuite.Col>

                            ))}
                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>



            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}

export default UserIndex;